import React from 'react';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import Discography from './components/Discography';
import LyricsSection from './components/LyricsSection';
import AudioPlayer from './components/AudioPlayer';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App min-h-screen bg-[#0a1128]">
      <Header />
      <main>
        <Hero />
        <Discography />
        <LyricsSection />
        <Footer />
      </main>
      <AudioPlayer />
    </div>
  );
}

export default App;